module.exports = __webpack_public_path__ + "static/media/NRF-client.a94b271d.png";